import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuService } from '../menu.service';

declare var jQuery: any;
declare var init: any;

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit, OnDestroy {

  constructor(public menuCtrl: MenuService) { }

  ngOnInit() {
    let el = document.getElementById("nav-toggle");
    let nav = document.getElementById("nav__content");
    let inNav = document.getElementById("sectores-items");
    let sect = document.getElementById("sector");
    let subStatus = false;
    
    sect.onclick = function() {
      subStatus = !subStatus;
      myFunction();
    };

    function myFunction() {
      if (subStatus == true ){
        inNav.style.height = "150px";
      }else{
        inNav.style.height = "0px";
      }

      
      /*for(let i = 0; i < inNav.length; i++) {
        inNav[i].style.display ="block";
      }*/
    }

    // paceLoad();
  }
  ngOnDestroy() {
    // this.menuCtrl.pageTransOut();
  }
  validate() {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation')

    // Loop over them and prevent submission
    Array.prototype.filter.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        if (form.checkValidity() === false || (form.reason.value == '' || form.reason.value == undefined)) {
          event.preventDefault()
          event.stopPropagation()
        }
        if (form.reason.value == '' || form.reason.value == undefined) {
          // let el = document.querySelector();
          jQuery('#reason-msg').css('display', 'block');
        } else {
          jQuery('#reason-msg').css('display', 'none');
        }
        form.classList.add('was-validated');
      }, false)
    })
  }
}
